export enum CountryCode {
  CH = 'CH',
  DE = 'DE',
  FR = 'FR',
  IT = 'IT',
  AT = 'AT',
  LI = 'LI',
  AF = 'AF',
  AL = 'AL',
  DZ = 'DZ',
  AS = 'AS',
  AD = 'AD',
  AO = 'AO',
  AI = 'AI',
  AQ = 'AQ',
  AG = 'AG',
  AR = 'AR',
  AM = 'AM',
  AW = 'AW',
  AZ = 'AZ',
  AU = 'AU',
  BS = 'BS',
  BH = 'BH',
  BD = 'BD',
  BB = 'BB',
  BY = 'BY',
  BE = 'BE',
  BZ = 'BZ',
  BJ = 'BJ',
  BM = 'BM',
  BT = 'BT',
  BO = 'BO',
  BA = 'BA',
  BW = 'BW',
  BV = 'BV',
  BR = 'BR',
  IO = 'IO',
  BG = 'BG',
  BF = 'BF',
  BI = 'BI',
  CL = 'CL',
  CN = 'CN',
  CO = 'CO',
  CK = 'CK',
  CR = 'CR',
  DJ = 'DJ',
  DM = 'DM',
  DO = 'DO',
  DK = 'DK',
  SV = 'SV',
  CI = 'CI',
  EC = 'EC',
  ER = 'ER',
  EE = 'EE',
  FK = 'FK',
  FJ = 'FJ',
  FI = 'FI',
  TF = 'TF',
  GF = 'GF',
  PF = 'PF',
  FO = 'FO',
  GA = 'GA',
  GM = 'GM',
  GE = 'GE',
  GH = 'GH',
  GI = 'GI',
  GD = 'GD',
  GR = 'GR',
  GB = 'GB',
  GL = 'GL',
  GP = 'GP',
  GU = 'GU',
  GT = 'GT',
  GG = 'GG',
  GN = 'GN',
  GW = 'GW',
  GY = 'GY',
  HT = 'HT',
  HM = 'HM',
  HN = 'HN',
  HK = 'HK',
  IN = 'IN',
  ID = 'ID',
  IM = 'IM',
  IQ = 'IQ',
  IR = 'IR',
  IE = 'IE',
  IS = 'IS',
  IL = 'IL',
  JM = 'JM',
  JP = 'JP',
  JE = 'JE',
  JO = 'JO',
  VG = 'VG',
  VI = 'VI',
  KY = 'KY',
  KH = 'KH',
  CM = 'CM',
  CA = 'CA',
  CV = 'CV',
  KZ = 'KZ',
  QA = 'QA',
  KE = 'KE',
  KG = 'KG',
  KI = 'KI',
  CC = 'CC',
  KM = 'KM',
  CG = 'CG',
  CD = 'CD',
  XK = 'XK',
  HR = 'HR',
  CU = 'CU',
  KW = 'KW',
  BQ = 'BQ',
  LA = 'LA',
  LS = 'LS',
  LV = 'LV',
  LB = 'LB',
  LR = 'LR',
  LT = 'LT',
  LU = 'LU',
  LY = 'LY',
  MO = 'MO',
  MG = 'MG',
  MW = 'MW',
  MY = 'MY',
  MV = 'MV',
  ML = 'ML',
  MT = 'MT',
  MA = 'MA',
  MH = 'MH',
  MQ = 'MQ',
  MR = 'MR',
  MU = 'MU',
  YT = 'YT',
  MK = 'MK',
  MX = 'MX',
  FM = 'FM',
  MD = 'MD',
  MC = 'MC',
  MN = 'MN',
  ME = 'ME',
  MS = 'MS',
  MZ = 'MZ',
  MM = 'MM',
  NA = 'NA',
  NR = 'NR',
  NP = 'NP',
  NC = 'NC',
  NZ = 'NZ',
  NI = 'NI',
  NL = 'NL',
  AN = 'AN',
  NE = 'NE',
  NG = 'NG',
  NU = 'NU',
  KP = 'KP',
  MP = 'MP',
  NF = 'NF',
  NO = 'NO',
  OM = 'OM',
  PK = 'PK',
  PW = 'PW',
  PS = 'PS',
  PA = 'PA',
  PG = 'PG',
  PY = 'PY',
  PE = 'PE',
  PH = 'PH',
  PN = 'PN',
  PL = 'PL',
  PT = 'PT',
  PR = 'PR',
  RW = 'RW',
  RO = 'RO',
  RU = 'RU',
  RE = 'RE',
  KN = 'KN',
  MF = 'MF',
  SB = 'SB',
  ZM = 'ZM',
  WS = 'WS',
  SM = 'SM',
  BL = 'BL',
  SA = 'SA',
  SE = 'SE',
  SN = 'SN',
  RS = 'RS',
  SC = 'SC',
  SL = 'SL',
  ZW = 'ZW',
  SG = 'SG',
  SK = 'SK',
  SI = 'SI',
  SO = 'SO',
  ES = 'ES',
  LK = 'LK',
  SH = 'SH',
  LC = 'LC',
  PM = 'PM',
  VC = 'VC',
  SD = 'SD',
  SR = 'SR',
  SJ = 'SJ',
  SZ = 'SZ',
  SY = 'SY',
  ST = 'ST',
  GS = 'GS',
  ZA = 'ZA',
  KR = 'KR',
  TJ = 'TJ',
  TW = 'TW',
  TZ = 'TZ',
  TH = 'TH',
  TL = 'TL',
  TG = 'TG',
  TK = 'TK',
  TO = 'TO',
  TT = 'TT',
  TD = 'TD',
  CZ = 'CZ',
  TN = 'TN',
  TM = 'TM',
  TC = 'TC',
  TV = 'TV',
  TR = 'TR',
  UG = 'UG',
  UA = 'UA',
  HU = 'HU',
  UY = 'UY',
  UZ = 'UZ',
  VU = 'VU',
  VA = 'VA',
  VE = 'VE',
  AE = 'AE',
  US = 'US',
  VN = 'VN',
  WF = 'WF',
  CX = 'CX',
  BN = 'BN',
  EH = 'EH',
  YE = 'YE',
  CF = 'CF',
  CY = 'CY',
  EG = 'EG',
  GQ = 'GQ',
  ET = 'ET',
  AX = 'AX',
  UM = 'UM',
}
